import { Component, EventEmitter, OnDestroy, OnInit, ViewEncapsulation, Output, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DynamicDatacenterFilter, DropdownFilter } from '../../../models/datacenter-filters';
import { pageTransitions } from '../../../animations/page-transitions';
import { LoadingSpinnerComponent } from '../../utils/loading-spinner.component';
import { AdditionalInput } from '../../../models/datacenter-aggrid-view';
import { ProductListFilterApiService } from '../services/product-list-filter-api.service';

@Component({
	selector: 'copo-product-dropdown-filter',
	templateUrl: './view-dropdown-filter.component.html',
	styleUrl: './view-dropdown-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	providers: [ProductListFilterApiService],
	imports: [
		NgIf,
		NgFor,
		MatIconModule,
		MatRippleModule,
		LoadingSpinnerComponent,

		MatFormFieldModule,

		MatSelectModule,

		MatOptionModule
	]
})
export class DropdownFilterComponent
implements OnInit, OnDestroy, DynamicDatacenterFilter<DropdownFilter> {
	@Input() filter?: DropdownFilter;
	@Input() additionalInput?: AdditionalInput;
	@Output() readonly removeFilter = new EventEmitter<void>();
	filteredItems: { code?: string | undefined; translation: string }[] = [];
	isLoading = true;
	showDropdown = false;
	itemsSub?: Subscription;

	constructor(
		private readonly filterApiService: ProductListFilterApiService
	) {}

	ngOnInit() {
		this.filterApiService.datacenterFilter = this.filter;
		if (this.additionalInput) {
			this.itemsSub = this.filterApiService
				.getItemBySearchTextAndAdditionalInput(this.additionalInput).subscribe({
					next: value => {
						this.filteredItems = value;
						this.isLoading = false;
						this.sortValues();
					},
					error: (error: unknown) => {
						console.error(error);
						this.isLoading = false;
					}
				});
		}
	}

	ngOnDestroy() {
		if (this.itemsSub) {
			this.itemsSub.unsubscribe();
		}
	}

	removeValue(index: number) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(index, 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	compareItems = (
		ob1: { translation: string },
		ob2: { translation: string }
	) => ob1.translation === ob2.translation;

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues()
					.filter(filterValue => !filterValue.translation || !filterValue.code)
			};
		}
		return undefined;
	}

	private sortValues() {
		this.filteredItems = this.filteredItems.filter(item => item.translation);
		this.filteredItems = this.filteredItems.toSorted(
			(f1, f2) => f1.translation.localeCompare(f2.translation)
		);
	}
}
